import React, { Component } from 'react'
import { Tab } from 'semantic-ui-react'

import MerchandiseCodes from './MerchandiseCodes'

import utils from '../../utils'

class Rewards extends Component {
  tabPanes = () => ({
    'merchandise-codes': {
      menuItem: 'Merchandise Codes',
      render: this.renderMerchandiseCodes,
    }
  })

  onTabChange = index => {
    const { history } = this.props
    const tabs = Object.keys(this.tabPanes())
    const queryString = tabs[index] ? `?tab=${tabs[index]}` : ''

    history.push(`/rewards${queryString}`)
  }

  renderMerchandiseCodes = () => {
    return (
      <Tab.Pane color="black" attached={false} style={{ height: 'calc(100vh - 180px)' }}>
        <MerchandiseCodes />
      </Tab.Pane>
    )
  }

  render() {
    const params = utils.helpers.urlParams()
    const tab = params.tab || 'merchandise-codes'
    const tabIndex = Object.keys(this.tabPanes()).indexOf(tab)

    return (
      <Tab
        activeIndex={tabIndex}
        menu={{ pointing: true }}
        panes={Object.values(this.tabPanes())}
        onTabChange={(e, { activeIndex }) => this.onTabChange(activeIndex)}
      />
    )
  }
}

export default Rewards



// WEBPACK FOOTER //
// ./src/containers/rewards/index.js